import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Terms() {
  const [text, setText] = useState("Loading...");

  useEffect(() => {
    fetch("/terms.txt")
      .then((r) => r.text())
      .then(setText)
      .catch(() => setText("Failed to load Terms of Service."));
  }, []);

  return (
    <div style={{ padding: "40px", color: "white", whiteSpace: "pre-wrap" }}>
      <h1>Terms of Service</h1>
      <pre style={{ whiteSpace: "pre-wrap", fontSize: "1.1rem" }}>{text}</pre>
      <Link to="/" className="btn">Back</Link>
    </div>
  );
}
